import { render, staticRenderFns } from "./coverPopup.vue?vue&type=template&id=6dfb3982&scoped=true"
import script from "./coverPopup.vue?vue&type=script&lang=js"
export * from "./coverPopup.vue?vue&type=script&lang=js"
import style0 from "./coverPopup.vue?vue&type=style&index=0&id=6dfb3982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb3982",
  null
  
)

export default component.exports